import * as icons from 'core/icons';

const bodegas = {
    id: 'bodega',
    title: 'Bodega',
    type: 'group',
    collapse: false,
    visible: true,
    children: [
        {
            id: 'dashboard',
            title: 'Cuadro Mandos',
            type: 'item',
            visible: true,
            url: '/b2b/bodegas/dashboard',
            icon: icons.DashboardIcon,
            breadcrumbs: false
        },
        {
            id: 'tramites',
            title: 'Tramites',
            type: 'item',
            visible: true,
            url: '/b2b/bodegas/tramites',
            icon: icons.TramitesIcon,
            breadcrumbs: false
        },
        {
            id: 'declaraciones',
            title: 'Declaraciones',
            type: 'item',
            visible: true,
            url: '/b2b/bodegas/declaraciones',
            icon: icons.DeclaracionesIcon,
            breadcrumbs: false
        },
        {
            id: 'validacion',
            title: 'Validacion Cosecha',
            type: 'item',
            visible: true,
            url: '/b2b/bodegas/validacion',
            icon: icons.InspeccionesIcon,
            breadcrumbs: false
        },
        {
            id: 'contable',
            title: 'Contabilidad',
            type: 'item',
            visible: true,
            url: '/b2b/bodegas/contabilidad',
            icon: icons.ContabilidadIcon,
            breadcrumbs: false
        }
    ]
};

export default bodegas;
